'use client'

import { useId, useState } from 'react'

import type { JSX } from 'react'

const EXPLANATION =
  'This is a salary estimation based on an analysis of comparable positions within the same geographical area.'

/**
 * Flags a salary the platform estimated rather than the employer published. `inline` is for places
 * inside a link (the job card): text only, explanation for screen readers, nothing focusable, since a
 * button inside an `<a>` is invalid. `disclosure` is for standalone places (the job detail facts): a
 * real button that shows and hides the explanation.
 */
export default function AiEstimatedLabel({ mode }: { mode: 'inline' | 'disclosure' }): JSX.Element {
  const [open, setOpen] = useState(false)
  const explanationId = useId()
  const label = 'font-sans font-medium text-3xs text-ink-secondary'

  if (mode === 'inline')
    return (
      <span className={label}>
        Estimated
        <span className="sr-only">. {EXPLANATION}</span>
      </span>
    )

  return (
    <span className="inline-flex flex-col gap-1">
      <button
        type="button"
        aria-expanded={open}
        aria-controls={explanationId}
        onClick={() => setOpen((o) => !o)}
        className={`${label} cursor-pointer underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent`}
      >
        Estimated
      </button>
      <span id={explanationId} hidden={!open} className="font-sans text-2xs text-ink-secondary">
        {EXPLANATION}
      </span>
    </span>
  )
}
